// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { areIntervalsOverlapping as fn } from "../areIntervalsOverlapping.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const areIntervalsOverlappingWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default areIntervalsOverlappingWithOptions;
